module.exports = __webpack_public_path__ + "01e84400c7df1259e59fb7b2e275b946.svg";